export default __webpack_public_path__ + "static/codemymobile_website_2_blue_white_ReactJS_section_02-1fa4c5d3e01993fcd522bd02ecc9ca8a.jpg";